import authHeader from "@/services/auth/AuthHeader";
import axios from "axios";

class MerchantService {
    // Lists every merchant (company document) on the platform. SUPER_ADMIN only (server-enforced
    // via the /api/superadmin/** rule).
    listAllMerchants(){
        let url = '/api/superadmin/merchant/listAllMerchants';
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    // Changes a merchant's slug and repoints the whole tenant at it. SUPER_ADMIN only; the server
    // refuses once the merchant has orders or terminals (see MerchantRenameService for why).
    renameMerchant(merchant, newMerchant){
        let url = '/api/superadmin/merchant/renameMerchant';
        let basicAuth = authHeader();
        return axios.post(url, { merchant: merchant, newMerchant: newMerchant }, { headers: basicAuth });
    }

    // Writes the Storefront stylesheets into the merchant's S3 folder. New merchants get these at
    // onboarding; this is the repair for one that predates the seeding, or whose seeding failed.
    // The server REFUSES if the files already exist unless overwrite is true — they may be hand-edited
    // and S3 is the only copy.
    seedStorefrontCss(merchant, overwrite){
        let url = '/api/onboarding/seedStorefrontCss';
        let basicAuth = authHeader();
        return axios.post(url, { merchant: merchant, overwrite: !!overwrite }, { headers: basicAuth });
    }

    // Full tenant teardown. SUPER_ADMIN only; the server refuses if the merchant has any orders.
    deleteMerchant(merchant){
        let url = '/api/superadmin/merchant/deleteMerchant';
        let basicAuth = authHeader();
        return axios.post(url, { merchant: merchant }, { headers: basicAuth });
    }
}

export default new MerchantService();
